import React from 'react';
export function Footer() {
  return <footer className="w-full bg-slate-900 px-8 py-14 text-stone-50 sm:px-14" data-id="element-130" data-mp="32wd0e9mw79qd">
      <div className="mx-auto max-w-6xl" data-id="element-131" data-mp="3ggaqfufcyb4x">
        <p className="font-serif text-3xl tracking-tight" data-id="element-132" data-mp="3ghc0pwojutll">
          ФИЗИЧКО СПРЕМНО<span className="align-super text-[0.5em]" data-id="element-133" data-mp="32pfgsfx1bq0a">™</span>
        </p>
        <p className="mt-3 max-w-xl text-sm leading-relaxed text-stone-50/60" data-id="element-134" data-mp="36ooaxlvzlpwd">
          ФИЗИЧКО СПРЕМНО™ је самостални наставни материјал; није издање нити одобрење Министарства просвете.
        </p>
        <p className="mt-10 border-t border-white/10 pt-6 text-xs text-stone-50/60" data-id="element-135" data-mp="38z70lzg0p09">
          © 2026 ФИЗИЧКО СПРЕМНО™. Сва права задржана.
        </p>
      </div>
    </footer>;
}